module.exports = __webpack_public_path__ + "img/10-02.b0e7abf4.png";